import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default' | 'outlined' | 'elevated';
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant = 'default', children, ...props }, ref) => {
    const { colors } = useTheme();
    const baseStyles = 'rounded-xl';
    const variantStyles = {
      default: cn(colors.surface, 'border shadow-bf', colors.border),
      outlined: cn(colors.surface, 'border-2', colors.border),
      elevated: cn(colors.surface, 'border shadow-bf-md', colors.border),
    };

    return (
      <div
        ref={ref}
        className={cn(baseStyles, variantStyles[variant], className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
